import React, { useState } from 'react';
import { Modal, Form, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet, faPlus } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';
import { useCriarConta } from 'hooks/useContas';
import { CriarContaDto } from 'services/contaService';

interface ModalCriarContaProps {
    show: boolean;
    onHide: () => void;
}

const ModalCriarConta: React.FC<ModalCriarContaProps> = ({ show, onHide }) => {
    const [nome, setNome] = useState('');
    const [erro, setErro] = useState('');

    const criarContaMutation = useCriarConta();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErro('');

        if (!nome.trim()) {
            setErro('O nome da conta é obrigatório');
            return;
        }

        try {
            const dto: CriarContaDto = { nome: nome.trim() };
            await criarContaMutation.mutateAsync(dto);

            setNome('');
            onHide();
        } catch (error: any) {
            setErro(error?.response?.data?.message || 'Erro ao criar conta');
        }
    };

    const handleClose = () => {
        setNome('');
        setErro('');
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FontAwesomeIcon icon={faWallet} className="me-2 text-primary-emphasis" />
                    Nova Conta
                </Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {erro && (
                        <Alert variant="danger" className="mb-3 border border-danger border-opacity-25 bg-danger-subtle">
                            <div className="text-danger-emphasis">{erro}</div>
                        </Alert>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label>Nome da Conta *</Form.Label>
                        <Form.Control
                            type="text"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            placeholder="Ex: Conta Corrente, Poupança, Caixa..."
                            required
                            disabled={criarContaMutation.isPending}
                        />
                        <Form.Text className="text-body-secondary">
                            Digite um nome descritivo para identificar esta conta
                        </Form.Text>
                    </Form.Group>

                    <Alert variant="info" className="small border border-info border-opacity-25 bg-info-subtle">
                        <div className="text-info-emphasis">
                            <FontAwesomeIcon icon={faWallet} className="me-2" />
                            A conta será criada com saldo inicial de R$ 0,00. Use as opções de depósito para adicionar valores.
                        </div>
                    </Alert>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                        disabled={criarContaMutation.isPending}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={criarContaMutation.isPending || !nome.trim()}
                    >
                        {criarContaMutation.isPending ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Criando...
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faPlus} className="me-2" />
                                Criar Conta
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ModalCriarConta; 